var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoWithdrawalTransaction = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23.999,
    viewBox: "0 0 23 23.999",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_withdrawal_transaction",
    d: "M315.59,886.7v-.372a2.284,2.284,0,0,0-2.322-2.245H294.933a2.284,2.284,0,0,0-2.329,2.236v.383Zm-14.346,15.494h-6.311a2.531,2.531,0,0,1-1.729-.94,2.734,2.734,0,0,1-.6-1.932V887.6H315.6v9.048a8.343,8.343,0,0,0-11.65-.55,8.055,8.055,0,0,0-2.7,6.006v.093Zm-6.06-11.862a.813.813,0,0,0-.715.87v2.583a.806.806,0,0,0,.715.868h4.206a.8.8,0,0,0,.714-.868V891.2a.807.807,0,0,0-.714-.87Zm14.315,5.754a6,6,0,1,0,6.1,6,6.048,6.048,0,0,0-6.1-6Zm4.091,8.1h0l-1.661,1.626a.493.493,0,0,1-.689,0,.473.473,0,0,1-.142-.34.465.465,0,0,1,.144-.339l.824-.8h-6.317a.48.48,0,1,1,0-.959H313.3a.472.472,0,0,1,.286.814Zm-.341-2.885h-7.561a.483.483,0,0,1-.339-.185.489.489,0,0,1,.056-.633h0l1.66-1.625a.492.492,0,0,1,.688-.008.472.472,0,0,1,.009.677l-.01.01-.823.8h6.317a.479.479,0,1,1,0,.958Z",
    transform: "translate(-292.597 -884.082)",
    fill: "#00a1af"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoWithdrawalTransaction);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_withdrawal_transaction.6ed6565a1c6ead9866db8cae724bb75f.svg";